(ns frontend.test.layout.view
  (:require
   [clojure.string :as string]
   [ui.components.layout.view :as layout]
   [ui.components.text.view :as text]))

(defn vertical
  []
  [layout/flex-flow
   [text/label {} "1 child"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
              border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-8 bg-danger-light flex-0"}]
     [layout/remaining-space]]]

   [text/label {} "1 child - fill"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                   border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-8 bg-danger-light flex-1"}]]]

   [text/label {} "1 child - scroll-y"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                   border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-[400px] bg-danger-light flex-0 overflow-y-auto"}
      (->> (range 0 100)
           (map (fn [i]
                  [:div (str "Row " i)]))
           (doall))]]]

   [text/label {} "1 child - scroll both"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                        border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-[400px] bg-danger-light flex-0 overflow-y-auto"}
      (->> (range 0 100)
           (map (fn [i]
                  [:div
                   {:style {:white-space "nowrap"}}
                   (str "Row " i
                        " "
                        (->> (range 0 10)
                             (map (fn [n]
                                    (str "........." n)))
                             (string/join)))]))
           (doall))]]]

   [text/label {} "2 children"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                             border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-8 bg-danger-light flex-0"}]
     [:div
      {:class "h-8 bg-danger-light flex-1"}]]]

   [text/label {} "2 - 1st fixed height"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                                  border border-solid border-base-light-border-paler"}
     [:div
       {:class "h-8 bg-danger-light flex-0"}]
     [:div
       {:class "h-8 bg-warning-light flex-1"}]]]

   [text/label {} "Header - body - footer"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                                       border border-solid border-base-light-border-paler"}
     [:div
      {:class "h-8 bg-danger-light flex-0"}]
     [:div
      {:class "h-8 bg-danger-light flex-0"}]
     [:div
      {:class "h-8 bg-base-regular flex-1"}]
    ]]

  ])

(defn horizontal
  []
  [layout/flex-flow
   [text/label {} "1 child"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                                            border border-solid border-base-light-border-paler"}
     [:div
      {:class "w-8 bg-danger-light flex-0"}]
     [layout/remaining-space]]]

   [text/label {} "1 child - fill"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                                                 border border-solid border-base-light-border-paler"}
     [:div
      {:class "w-8 bg-danger-light flex-1"}]]]

   [text/label {} "1 child - scroll-y"
    [:div
     {:class "w-full h-full flex flex-1 gap-2 items-start max-w-[300px] w-[300px] max-h-[300px] h-[300px]
                                                      border border-solid border-base-light-border-paler"}
     [:div
      {:class "max-h-full overflow-y-auto w-8 bg-danger-light flex-1"}
      (->> (range 0 100)
           (map (fn [i]
                  [:div (str "Row " i)]))
           (doall))]]]
  ]
)

(defn view
  []
  [:div
   {:class "p-3 w-full h-full flex flex-1 gap-2 items-start"}
   [text/h1 {} "Layouts"]

   [text/h2 "Vertical"]
   [vertical]

   [text/h2 "Horizontal"]
   [horizontal]

   [layout/remaining-space]])
